module.exports = __webpack_public_path__ + "static/media/defaultI.8a382e6b.svg";